'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cookieNames = undefined;
exports.default = reducer;
exports.hideAd = hideAd;
exports.hideCookie = hideCookie;

var _qim = require('qim');

var HIDE_AD = 'adbar/HIDE_AD';
var HIDE_COOKIE = 'adbar/HIDE_COOKIE';

var cookieNames = exports.cookieNames = {
  cookieBar: 'cookiePolicyBarHidden',
  adBar: 'adBarHideTime'
};

var initialState = {
  adBarHidden: false,
  cookieBarHidden: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case HIDE_AD:
      {
        return (0, _qim.set)('adBarHidden', true, state);
      }
    case HIDE_COOKIE:
      {
        return (0, _qim.set)('cookieBarHidden', true, state);
      }
    default:
      {
        return state;
      }
  }
}

function hideAd() {
  return {
    type: HIDE_AD
  };
}

function hideCookie() {
  return {
    type: HIDE_COOKIE
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/adbar.js
// module id = 530
// module chunks = 1